import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ROLES } from "../../constants/UserRoles";
import ViewGuideMain from "../../components/orgAdmin/prepGuides/preparation/ViewGuideMain";

function OrgAdminViewGuideMaster() {
  const [guideDetails, setGuideDetails] = useState();
  const guideData = (value) => {
    setGuideDetails(value);
  };
  return (
    <div className="hirePlusPlusPageContent ">
      <Sidebar
        activePage="preparationGuides"
        collapseSidbar="left"
        userRole={ROLES.org_admin}
      />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          activePage="preparationGuides"
          userRole={ROLES.org_admin}
          newTitle={guideDetails?.jobTitle}
          // driverFlag="viewSingleGuide"
        />
        <ViewGuideMain guideData={guideData} />
      </div>
    </div>
  );
}

export default OrgAdminViewGuideMaster;
